<app-landingpage-header-child></app-landingpage-header-child>
<section class="home-page pt-4 pb-4" *ngIf="showContent">
    <div class="container p-4">
        <div class="row">
            <div class="col-8 offset-2 text-center">
                <h4>{{'alert.page_not_found' | translate}}</h4>
                <h4>
                    {{'alert.back_home' | translate}}
                    <a class="navbar-brand brand-name" routerLink="{{linkHome}}">
                        <h4>{{'button.back_home' | translate}}</h4>
                    </a>
                </h4>
                <button mat-stroked-button color="primary" type="button" routerLink="{{linkHome}}">
                    <mat-icon class="mr-0">arrow_back</mat-icon>
                    {{ 'update_enterprise.buttons.btn_back_home' | translate }}
                </button>
            </div>
        </div>
    </div>
</section>
<app-landingpage-footer></app-landingpage-footer>